// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"a5b86560","234":"52948101","743":"02f609c9","812":"d7605e20","876":"df23590d"}[chunkId] + ".css";
};